(function () {
    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
    }
    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
    }
    function addProductId(id) {
        if (!id) return;
        var current = getCookie('recently_viewed_products');
        var items = current ? current.split(',') : [];
        items = items.filter(function (item) { return item !== String(id); });
        items.unshift(String(id));
        if (items.length > 30) { items = items.slice(0, 30); }
        setCookie('recently_viewed_products', items.join(','), 365);
    }
    document.addEventListener('DOMContentLoaded', function () {
        if (window.currentProductId) {
            addProductId(window.currentProductId);
        }
    });
})();